import * as globals from '@wandb/weave/common/css/globals.styles';
import styled, {css} from 'styled-components';

export const HorizontalRule = styled.hr<{selected?: boolean}>`
  margin: 16px 0;
  border-top: none;
  border-bottom: 1px solid ${globals.THEME.border};
  ${props =>
    props.selected &&
    css`
      border-bottom: 1px solid light-dark(rgb(208, 225, 252), var(--blue-700));
      box-shadow: 0 0 0 2px light-dark(rgb(208, 225, 252), var(--blue-700));
    `}
`;
